const imgs = []

export function loadImg() {
    imgs.forEach((src) => {
        const img = new Image()
        img.src = src
    })
}
